import { render, staticRenderFns } from "./myScreens.vue?vue&type=template&id=750fba7c&scoped=true"
import script from "./myScreens.vue?vue&type=script&lang=js"
export * from "./myScreens.vue?vue&type=script&lang=js"
import style0 from "./myScreens.vue?vue&type=style&index=0&id=750fba7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750fba7c",
  null
  
)

export default component.exports